module.exports = __webpack_public_path__ + "static/media/roadmap.b2b8c519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roadmap.svg
// module id = 1770
// module chunks = 0